import React from "react";
import CollapsibleTable from ".";

const PlatingRule: React.FC = () => {
    return (
        <>
            <CollapsibleTable />
        </>
    );
};

export default PlatingRule;
